import { IImageInfo } from "@types";

type AIColumnType = "aiLabel" | "score";
interface AITableCellProps {
  inspStatus: InspStatusItem | null;
  inspResult: any[];
  row: IImageInfo;
  isVisible: boolean;
}

export const AITableCell = ({ inspResult, row, isVisible, column }: AITableCellProps & { column: AIColumnType }) => {
  const datasetDir = "/data1/datasets";
  const fullRowPath = row.path.startsWith(datasetDir) ? row.path : `${datasetDir}${row.path}`;

  const rowData = (inspResult ?? []).find((result) => result.path === fullRowPath);
  const isMatched = !!rowData && !rowData.error;
  const hasError = !!rowData?.error;
  const textColor = isMatched ? "var(--table-text-highlight)" : "var(--table-text)";

  const value = (() => {
    if (hasError) return "Error";
    switch (column) {
      case "aiLabel":
        return isMatched ? rowData!.AILabel : row.AILabel;
      case "score": {
        // 검사 결과에 score가 없으면 기존 값 유지, 기존 값도 없으면 Error
        const score = typeof rowData?.score === "number" ? rowData.score : row.score;
        return typeof score === "number" ? score.toFixed(4) : "Error";
      }
    }
  })();

  return (
    // 부모가 flex div 행이므로 td(TableCell) 대신 span — 고정 width/패딩이 열 폭을 밀어내지 않게
    <span
      style={{
        color: textColor,
        transform: isVisible ? "translateY(0)" : "translateY(-10px)",
        transition: "opacity 0.2s ease, transform 0.2s ease",
      }}
    >
      {value}
    </span>
  );
};
